'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
import Button from './Button';
type Props = {
  closeHandler: () => void;
  confirmHandler: (ruleId?: number) => void;
  spaceSlug: string;
};
const BanUserConfirmation = t0 => {
  const $ = _c(33);
  const {
    closeHandler,
    confirmHandler,
    spaceSlug
  } = t0;
  const [selectedRuleId, setSelectedRuleId] = useState(undefined);
  let t1;
  if ($[0] !== spaceSlug) {
    t1 = {
      queryKey: ["spaces", spaceSlug, "rules"],
      queryFn: () => unwrapFromResult(client.spaces.rules.query({
        slug: spaceSlug
      }))
    };
    $[0] = spaceSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: spaceRules,
    isLoading: loading
  } = useQuery(t1);
  let t2;
  if ($[2] !== confirmHandler || $[3] !== selectedRuleId) {
    t2 = () => {
      confirmHandler(selectedRuleId);
    };
    $[2] = confirmHandler;
    $[3] = selectedRuleId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleConfirm = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2>Ban User?</h2>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== closeHandler) {
    t4 = <ModalHeader closeHandler={closeHandler}>{t3}</ModalHeader>;
    $[6] = closeHandler;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="my-4 text-base text-textPrimary">Are you sure that you want to ban this user? You can later unban this user from the Manage Members page.</p>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <label className="mb-2 block text-sm font-emphasis text-textPrimary">Select the rule that was broken (optional):</label>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => setSelectedRuleId(e.target.value ? Number(e.target.value) : undefined);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = selectedRuleId || "";
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <option value="">No specific rule</option>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== spaceRules?.rules) {
    t10 = spaceRules?.rules.map(_temp);
    $[12] = spaceRules?.rules;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== spaceRules?.inherited) {
    t11 = spaceRules?.inherited.map(_temp3);
    $[14] = spaceRules?.inherited;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t8) {
    t12 = <ModalContent>{t5}<div className="mt-4">{t6}<select className="w-full rounded border border-ds-border-standard bg-background-primary p-2 text-textPrimary" onChange={t7} value={t8}>{t9}{t10}{t11}</select></div></ModalContent>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== closeHandler) {
    t13 = <Button text="Cancel" variant="SECONDARY" classNames="w-28" borderTransparent={false} onClick={closeHandler} />;
    $[20] = closeHandler;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== handleConfirm || $[23] !== loading) {
    t14 = <Button text="Ban User" classNames="w-fit ml-2" onClick={handleConfirm} loading={loading} disabled={loading} />;
    $[22] = handleConfirm;
    $[23] = loading;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <ModalFooter>{t13}{t14}</ModalFooter>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== closeHandler || $[29] !== t12 || $[30] !== t15 || $[31] !== t4) {
    t16 = <Modal closeHandler={closeHandler}>{t4}{t12}{t15}</Modal>;
    $[28] = closeHandler;
    $[29] = t12;
    $[30] = t15;
    $[31] = t4;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
export default BanUserConfirmation;
function _temp(rule) {
  return <option key={rule.id} value={rule.id}>{rule.title}</option>;
}
function _temp2(rule_0) {
  return <option key={rule_0.id} value={rule_0.id}>{rule_0.title} (sitewide)</option>;
}
function _temp3(tier) {
  return tier.rules.map(_temp2);
}